
// Importing the base PrimeVue component styles
import 'primevue/resources/primevue.min.css'
import '../styles/theme.css'

// Importing the base PrimeIcon styles
import 'primeicons/primeicons.css'
import Vue from 'vue'
import Calendar from 'primevue/calendar'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import Galleria from 'primevue/galleria'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Panel from 'primevue/panel'
import Message from 'primevue/message'
import { ProgressSpinner } from 'primevue/progressspinner'

export function bootstrapPrimeVue () {
    Vue.prototype.$primevue = { ripple: true }
    Vue.component('pv-dialog', Dialog)
    Vue.component('pv-input-text', InputText)
    Vue.component('pv-button', Button)
    Vue.component('pv-calendar', Calendar)
    Vue.component('pv-dropdown', Dropdown)
    Vue.component('pv-galleria', Galleria)
    Vue.component('pv-input-number', InputNumber)
    Vue.component('pv-pogress', ProgressSpinner)
    Vue.component('pv-panel', Panel)
    Vue.component('pv-message', Message)
}
